import Grid from "@material-ui/core/Grid";
import React, { useEffect, useState } from "react";

import { ErrorModal } from "@/components/shared/modal/error-modal";
import { Outlet } from "react-router-dom";
import { TableVendors } from "./components/VendorsDataTable/TableVendors";
import { useVendorsContext } from "./context/VendorsContext";
import { getVendors } from "./repositories/VendorsRepository";

export const Vendors = () => {
	const { state, actions } = useVendorsContext();
	const [isLoading, setIsLoading] = useState(true);

	const [fetchDataError, setFetchDataError] = useState<string | null>(null);

	const getVendorsFromAPI = async () => {
		setIsLoading(true);
		try {
			const { ok, vendors } = await getVendors();

			if (ok) {
				actions.setVendors(vendors);
				setIsLoading(false);
			}
		} catch (e: any) {
			setFetchDataError(e);
		}
	};

	useEffect(() => {
		getVendorsFromAPI();
	}, []);
	if (state.vendors) {
		return (
			<>
				<Grid container justifyContent="center" alignItems="center">
					<Grid item md={12} xs={12} style={{ margin: 0 }}>
						<div style={{ width: "100%", padding: "10px 0 20px" }}>
							<TableVendors
								isLoading={isLoading}
								getVendorsFromAPI={getVendorsFromAPI}
							/>
						</div>
						<Outlet />
					</Grid>
				</Grid>
				<ErrorModal
					onHide={() => setFetchDataError(null)}
					error={fetchDataError}
				/>
			</>
		);
	}
	return <></>;
};
